import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { IScheduleStreamContentActionPayload } from '../interfaces/schedule-stream-content.action-payload.interface';
import { MaxBrainScheduledStreamContent } from '../models/scheduled-stream-content.model';
import { IScheduleStreamContentBulkActionPayload } from '../interfaces/schedule-stream-content-bulk.action-payload.interface';
import { MaxBrainScheduledStreamContentBulk } from '../models/scheduled-stream-content-bulk.model';

export class SetScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] SetScheduledStreamContent';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class UnsetScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] UnsetScheduledStreamContent';
}

export class FetchScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] FetchScheduledStreamContent';

    constructor(public payload: string) {}
}

export class FetchScheduledStreamContentSuccess {
    static readonly type = '[ScheduledStreamContent] FetchScheduledStreamContentSuccess';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class FetchScheduledStreamContentFailure {
    static readonly type = '[ScheduledStreamContent] FetchScheduledStreamContentFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] CreateScheduledStreamContent';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}
export class CreateValidScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContent';

    constructor(public payload: IScheduleStreamContentActionPayload) {}
}

export class CreateValidScheduledStreamContentSuccess {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContentSuccess';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class CreateValidScheduledStreamContentFailure {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContentFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class CreateValidScheduledStreamContentBulk {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContentBulk';

    constructor(public payload: IScheduleStreamContentBulkActionPayload) {}
}

export class CreateValidScheduledStreamContentBulkSuccess {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContentBulkSuccess';

    constructor(public payload: MaxBrainScheduledStreamContentBulk) {}
}

export class CreateValidScheduledStreamContentBulkFailure {
    static readonly type = '[ScheduledStreamContent] CreateValidScheduledStreamContentBulkFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class CreateScheduledStreamContentSuccess {
    static readonly type = '[ScheduledStreamContent] CreateScheduledStreamContentSuccess';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class CreateScheduledStreamContentFailure {
    static readonly type = '[ScheduledStreamContent] CreateScheduledStreamContentFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] UpdateScheduledStreamContent';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class UpdateScheduledStreamContentSuccess {
    static readonly type = '[ScheduledStreamContent] UpdateScheduledStreamContentSuccess';

    constructor(public payload: MaxBrainScheduledStreamContent) {}
}

export class UpdateScheduledStreamContentFailure {
    static readonly type = '[ScheduledStreamContent] UpdateScheduledStreamContentFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] DeleteScheduledStreamContent';

    constructor(public payload: string) {}
}

export class DeleteScheduledStreamContentSuccess {
    static readonly type = '[ScheduledStreamContent] DeleteScheduledStreamContentSuccess';

    constructor(public payload: string) {}
}

export class DeleteScheduledStreamContentFailure {
    static readonly type = '[ScheduledStreamContent] DeleteScheduledStreamContentFailure';

    constructor(public payload: string) {}
}

export class SetScheduledStreamContents {
    static readonly type = '[ScheduledStreamContent] SetScheduledStreamContents';

    constructor(public payload: MaxBrainScheduledStreamContent[]) {}
}

export class AddAllScheduledStreamContents {
    static readonly type = '[ScheduledStreamContents] AddAllScheduledStreamContents';

    constructor(public payload: MaxBrainScheduledStreamContent[]) {}
}

export class FetchScheduledStreamContents {
    static readonly type = '[ScheduledStreamContents] FetchScheduledStreamContents';

    constructor(
        public payload: {
            audienceId: string;
            featuredStreamContentId: string;
            search?: string;
            pageSize?: number;
            pageNumber?: number;
            sortBy?: string;
            sortOrder?: string;
            selectedPostingTypeId?: string;
        }
    ) {}
}

export class FetchScheduledStreamContentsSuccess {
    static readonly type = '[ScheduledStreamContents] FetchScheduledStreamContentsSuccess';

    constructor(public payload: MaxBrainScheduledStreamContent[]) {}
}

export class FetchScheduledStreamContentsFailure {
    static readonly type = '[ScheduledStreamContents] FetchScheduledStreamContentsFailure';
}

export class ToggleSelectedScheduledStreamContent {
    static readonly type = '[ScheduledStreamContent] ToggleSelectedScheduledStreamContent';

    constructor(public payload: string) {}
}

export class SelectFilteredScheduledStreamContents {
    static readonly type = '[ScheduledStreamContent] SelectFilteredScheduledStreamContents';
}

export class DeselectSelectedScheduledStreamContents {
    static readonly type = '[ScheduledStreamContent] DeselectSelectedScheduledStreamContents';
}

export class SearchScheduledStreamContents {
    static readonly type = '[ScheduledStreamContent] SearchScheduledStreamContents';

    constructor(public payload: string) {}
}
